import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_SERVER_URL || "http://localhost:3000",
  withCredentials: true,
  headers: { pragma: "no-cache" },
});

export const request = (method, url, data) =>
  api.request({ method, url, data });

export default api;
